import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Formatters, Messages } from '~src/codegen/Localize';

import { IParsedPublishToSalesforceResponse } from '../restApi/requests/PublishToSalesforce';


export const successToastTestId = 'publish-to-salesforce-success';
export const errorToastTestId = 'publish-to-salesforce-error';

interface PublishToSalesforceToastParams {
  appName: string;
  numSuccesses: number;
  numFailures: number;
  successName: string;
  successUrl: string;
  failureName: string;
}

export class PublishToSalesforceToaster {
  private static toaster = ToasterService.instance;

  /**
   * Pops a generic failure toast. This should be used for failures during the publish api call.
   */
  public static popGenericPublishError() {
    this.toaster.pop({
      type: ToastType.Error,
      text: Messages.publishToSalesforcePublishCannotPublishError(),
    });
  }

  public static popPublishSuccessToast(parsedResponse: IParsedPublishToSalesforceResponse) {
    const message: string = Messages.publishToSalesforcePublishSuccessToast({
      ITEM_COUNT: parsedResponse.numSuccesses,
      VIEW_NAME: parsedResponse.successName,
      APP_NAME: parsedResponse.appName,
      ITEM_COUNT_LOC: Formatters.formatCount(parsedResponse.numSuccesses)
    });

    this.toaster.pop({
      type: ToastType.Success,
      text: message,
      actionMessage: Messages.publishToSalesforceSuccessAction(),
      testId: successToastTestId,
      action: parsedResponse.successAction
    });
  }

  public static popPublishFailureToast(parsedResponse: IParsedPublishToSalesforceResponse) {
    const message: string = Messages.publishToSalesforcePublishErrorToast({
      ITEM_COUNT: parsedResponse.numFailures,
      VIEW_NAME: parsedResponse.failureNames[0],
      APP_NAME: parsedResponse.appName,
      ITEM_COUNT_LOC: Formatters.formatCount(parsedResponse.numFailures)
    });

    this.toaster.pop({
      type: ToastType.Error,
      text: message,
      testId: errorToastTestId
    });
  }
}